import update from 'immutability-helper';
import { reducerWithInitialState } from 'typescript-fsa-reducers';

import actions from './action';

export interface IReducerState {
  initialState: boolean;
}

const INITIAL_STATE: IReducerState = {
  initialState: false,
};

const reducer = reducerWithInitialState<IReducerState>(INITIAL_STATE)
  .case(
    actions.setInitialState,
    (state, payload): IReducerState => {
      return update(state, {
        initialState: {
          $set: payload,
        },
      });
    },
  )
  .case(actions.updateInitValue, (state, payload) => {
    return {
      ...state,
      initialState: payload.initValue,
    };
  })
  .build();

export default reducer;
